import { useState } from 'react';

export interface ModalData {
  title: string;
  description: string;
  type: 'error' | 'warning' | 'success' | 'info';
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
}

export const useModal = () => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [modalData, setModalData] = useState<ModalData>({
    title: '',
    description: '',
    type: 'error',
    confirmText: 'OK',
    cancelText: 'Anuluj'
  });

  const showModal = (
    title: string,
    description: string,
    type: 'error' | 'warning' | 'success' | 'info' = 'info',
    onConfirm?: () => void,
    confirmText?: string,
    cancelText?: string
  ) => {
    setModalData({
      title,
      description,
      type,
      onConfirm,
      confirmText: confirmText || (onConfirm ? 'Kontynuuj' : 'OK'),
      cancelText: cancelText || 'Anuluj'
    });

    if (onConfirm) {
      setShowConfirmModal(true);
    } else {
      setShowErrorModal(true);
    }
  };

  const showError = (title: string, description: string) => {
    showModal(title, description, 'error');
  };

  const showSuccess = (title: string, description: string) => {
    showModal(title, description, 'success');
  };

  const showWarning = (title: string, description: string) => {
    showModal(title, description, 'warning');
  };

  const showConfirm = (
    title: string,
    description: string,
    onConfirm: () => void,
    confirmText?: string,
    cancelText?: string
  ) => {
    showModal(title, description, 'warning', onConfirm, confirmText, cancelText);
  };

  const closeModal = () => {
    setShowErrorModal(false);
    setShowConfirmModal(false);
  };

  const confirmAction = () => {
    setShowConfirmModal(false);
    modalData.onConfirm?.();
  };

  return {
    showErrorModal,
    showConfirmModal,
    modalData,
    showModal,
    showError,
    showSuccess,
    showWarning,
    showConfirm,
    closeModal,
    confirmAction,
    setShowErrorModal,
    setShowConfirmModal
  };
};